import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

interface SwiperPanelProps {
  hasLink: boolean
}

interface InfoContainerProps {
  opacity: number
}

const Flex = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Wrapper = styled(Flex)`
  height: 256px;
  width: 100%;
  max-width: 1400px;
`
export const SwiperPanel = styled(Flex)<SwiperPanelProps>`
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
  border-radius: 10px;
  background: ${theme.colors.neutral.lighthover};

  .swiper-horizontal {
    height: 100%;
    width: 100%;
  }

  .swiper-slide {
    cursor: ${({ hasLink }) => (hasLink ? ' pointer' : 'default')};
  }

  .swiper-pagination {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .swiper-pagination-bullet {
    opacity: 1;
    width: 8px;
    height: 8px;
    background: transparent;
    border: 1px solid ${theme.colors.neutral.white};
    margin: 3px !important;
  }

  .swiper-pagination-bullet-active {
    width: 8px;
    height: 8px;
    background: ${theme.colors.neutral.white};
  }

  .swiper-button-next,
  .swiper-button-prev {
    ::after {
      color: ${theme.colors.neutral.white};
      font-size: 20px;
      font-weight: bold;
    }
  }

  .swiper-pagination-bullets.swiper-pagination-horizontal {
    bottom: 8px;
  }
`

export const SwiperImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: right;
`
export const InfoContainer = styled.div<InfoContainerProps>`
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 0 80px;
  gap: ${theme.spacing.md};
  transition: opacity 0.2s ease;
  z-index: 20;
  opacity: ${({ opacity }) => opacity};
  pointer-events: none;
`
export const InfoTitle = styled.h1`
  margin: 0;
  line-height: ${theme.typography.lineHeight.md};
  font-size: ${theme.typography.sizes.lg};
  font-weight: ${theme.typography.weight.xl};
  color: ${theme.colors.neutral.white};
  max-width: 500px;
`

export const InfoDescription = styled.p`
  margin: 0;
  line-height: ${theme.typography.lineHeight.md};
  font-size: ${theme.typography.sizes.sm};
  font-weight: ${theme.typography.weight.sm};
  color: ${theme.colors.neutral.white};
  white-space: pre-line;

  @media (max-width: ${theme.breakpoints.lg}px) {
    max-width: 450px;
  }
`

export const InfoBullet = styled.span`
  padding: 10px;
  line-height: ${theme.typography.lineHeight.sm};
  font-size: ${theme.typography.sizes.xs};
  font-weight: ${theme.typography.weight.lg};
  color: ${theme.colors.neutral.white};
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.2);
`
